import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { useEffect, useState } from 'react';
import { Horarios } from '../../../interfaces/entities/Horarios';
import { ScreeningHoursProps } from '../../../interfaces/props/SaudeOnline/PAVirtual/ScreeningHoursProps';
import './styles.css';
import { sxRadio } from './sxProps';

function ScreeningHours(props: ScreeningHoursProps) {
  const [hours, setHours] = useState<Horarios[]>([]);
  const [value, setValue] = useState<string>('');
  const { handleHour, hoursList, selectedDate, selectedHour } = { ...props };

  useEffect(() => {
    const locSelectedDate = selectedDate;
    if (locSelectedDate !== null) {
      const selectedHours = hoursList.filter(hour => hour.data === `${String(locSelectedDate.getDate()).padStart(2, '0')}/${String(locSelectedDate.getMonth() + 1).padStart(2, '0')}/${locSelectedDate.getFullYear()}`);
      setHours(selectedHours)
    }
  }, [selectedDate, hoursList]);

  useEffect(() => {
    if (selectedHour !== null) {

      const locSelectedHour = selectedHour;
      const index = hours.findIndex((hour: Horarios) => hour.hora === locSelectedHour.hora && hour.data === locSelectedHour.data);
      setValue(`${index}`);
    }
    else {
      setValue('')
    }

  }, [hours, selectedHour])

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue(event.target.value);
    handleHour(hours[Number(event.target.value)])
  };

  return (
    <div className="hours-holder">
      {selectedDate !== null &&
        <div>
          <h1 className='hours-title'>Horários disponíveis</h1>

          <div className="hours">
            <h1 className='hours-holder-title'>Selecione o horário para agendamento</h1>
            {hours.length > 0 &&
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                name="radio-buttons-group"
                value={value}
                onChange={handleChange}
              >
                {hours.map((hour: Horarios, index: number) => {
                  return (
                    <FormControlLabel value={index} control={<Radio size='small' />} label={`${hour.data} - ${hour.hora}`} key={hour.hora} sx={sxRadio} />
                    // <FormControlLabel value={index} control={<Radio size='small' />} label={`${hour.data} (${hour.diaSemana}) - ${hour.hora}`} key={hour.hora} sx={sxRadio} />
                  )
                })}
              </RadioGroup>
            }
            {hours.length === 0 &&
              <h1 className='hours-holder-message'>Data indisponível. Selecione outra data.</h1>
            }
          </div>

        </div>
      }
    </div>
  )
}

export default ScreeningHours;